import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit';

import { leagueApi } from '@/api/queries/league';
import { type LeaderboardData, type LeagueType } from '@/common/types/league';

interface LeaguesInitionStateType {
  list: LeagueType[] | null;
  leaderBoard: LeaderboardData | null;
  currentLeagueId?: number;
}

const initialState: LeaguesInitionStateType = {
  list: null,
  leaderBoard: null,
  currentLeagueId: undefined,
};

const leaguesSlice = createSlice({
  name: 'leagues',
  initialState,
  reducers: {
    clearMyRewardsByLeagueId: (
      state,
      { payload }: PayloadAction<{ leagueId: string }>,
    ) => {
      const league = state.list?.find(({ id }) => payload.leagueId === id);

      if (league) {
        league.myRewards = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isAnyOf(
          leagueApi.endpoints.getCurrentLeagueInfo.matchFulfilled,
          leagueApi.endpoints.getLeagueInfoById.matchFulfilled,
        ),
        (state, { payload }: PayloadAction<LeagueType>) => {
          if (state.list) {
            const league = state.list.find(
              (league) => league.id === payload.id,
            );

            if (league) {
              Object.assign(league, payload);
            } else {
              state.list.push(payload);
            }
          } else {
            state.list = [payload];
          }
        },
      )
      .addMatcher(
        leagueApi.endpoints.getLeagueBoard.matchFulfilled,
        (state, { payload }) => {
          state.leaderBoard = payload;
        },
      )
      .addMatcher(
        leagueApi.endpoints.getCurrentLeagueInfo.matchFulfilled,
        (state, { payload }: PayloadAction<LeagueType>) => {
          state.currentLeagueId = payload.nextLeagueId
            ? payload.nextLeagueId - 1
            : payload.prevLeagueId
              ? payload.prevLeagueId + 1
              : undefined;
        },
      );
  },
});

export const { clearMyRewardsByLeagueId } = leaguesSlice.actions;
export default leaguesSlice.reducer;
